<div class="title">{{ title() }}</div>
@if (loaded()) {
  <div>
    @if (note) {
      <div class="note">{{ note }}</div>
    }
    @if (emptyLabel) {
      <div class="no-data-msg">{{ emptyLabel }}</div>
    }
    <ng-content />
    @if (footerCTA) {
      <div class="footer">
        <span (click)="footerCTAClick.emit()">{{ footerCTA }}</span>
      </div>
    }
  </div>
}
@if (loading()) {
  <div>
    <gnx-dots-loader />
  </div>
}
@if (!loading() && !loaded()) {
  <div>{{ errorLabel() }}</div>
}
